import idx from '../helpers/idx';
import toggle from '../helpers/class-toggle';

export default () => {
	const buttons = document.querySelectorAll('.swatches__item');
	const activeBtn = document.querySelector('.swatches__item--active');
	const cursor = document.querySelector('.swatches__cursor');
	const labels = document.querySelectorAll('.swatches__label span');
	if (!activeBtn) return;

	if (buttons.length && cursor) {
		const inititalState = cursor.style.transform;
		const initialIndex = idx(activeBtn)

		buttons.forEach(function(btn, index) {
			btn.addEventListener('mouseenter', (e) => {
				const newIndex = index;

				let styleState = `translateX(${index * 100}%)`;
				toggle(labels, labels[index], 'is-active');
				cursor.style.transform = styleState;
			});
			btn.addEventListener('mouseleave', (e) => {
				cursor.style.transform = inititalState;
				toggle(labels, labels[initialIndex], 'is-active');
			});

		});
	}
};
